import axios from 'axios';
import { getToken } from '../helpers';

export const apiUrl = 'https://c-proxy.int.aspirity.com';

export const defaultParams = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
});

// Configurar interceptor para incluir o token automaticamente
axios.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      // Log apenas em desenvolvimento
      if (process.env.NODE_ENV === 'development') {
        console.log('🔐 Token enviado:', token.substring(0, 30) + '...');
      }
    } else {
      console.warn('⚠️ Nenhum token encontrado para:', config.url);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratar erros de autenticação
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token expirado ou inválido - redirecionar para login
      sessionStorage.removeItem('user');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default axios;
